import { render } from "./TransfertArgent.vue?vue&type=template&id=f9024db4&scoped=true&ts=true"
import script from "./TransfertArgent.vue?vue&type=script&lang=ts"
export * from "./TransfertArgent.vue?vue&type=script&lang=ts"

import "./TransfertArgent.vue?vue&type=style&index=0&id=f9024db4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9024db4"]])

export default __exports__